import React, { useMemo } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import HotelIcon from "@mui/icons-material/Hotel";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { Col, Row } from "react-bootstrap";
import {
  ItemCarritoHotel,
} from "../../../services/carritoServicios";
import {
  nochesADias,
  obtenerIntervalos,
  stringADate,
} from "../../../utils/dateUtils";
import { StyledCalendar } from "./organisms/StyledCalendar";
import { SeccionTransporte } from "./SeccionTransporte";
import CurrencyFormat from "react-currency-format";
import { parseCurrency } from "../../../utils/numberUtils";
import { HotelHandlers } from "./Model";
import { IconContainer } from "./organisms/IconContainer";
import DangerIconContainer from "../../organisms/DangerIconContainer";

export const ItemHotel = ({
  item,
  handlers,
  onEliminarItemClick,
}: {
  item: ItemCarritoHotel;
  handlers: HotelHandlers;
  onEliminarItemClick: () => void;
}) => {
  const noches: number = item.fechasProgramadas.length;
  const nochesIndividuales: number =
    item.datosNochesIndividuales?.nochesIndividuales || 0;
  const nochesPlan: number = noches - nochesIndividuales;

  const diasProgramados = useMemo(() => {
    const noches = item.fechasProgramadas;
    const dias = nochesADias(noches);
    return dias.map((dia) => stringADate(dia));
  }, [item.fechasProgramadas]);

  const numeroViajes = useMemo(() => {
    const datosTransp = item.datosTransporte;
    if (!datosTransp) {
      return 0;
    }
    return obtenerIntervalos(datosTransp.fechas).length;
  }, [item.datosTransporte]);

  const onPrecioFinalTarifaInputChange = (
    val: React.ChangeEvent<HTMLInputElement>
  ) => {
    const parsedPrecio = parseCurrency(val.target.value, "$", ",");
    handlers.onPrecioFinalTarifaChange({
      val: parsedPrecio,
      idMascota: item.mascota.id,
      idItem: item.id,
    });
  };

  const onPrecioFinalNocheIndividualInputChange = (
    val: React.ChangeEvent<HTMLInputElement>
  ) => {
    const parsedPrecio = parseCurrency(val.target.value, "$", ",");
    handlers.onPrecioFinalNocheIndividualChange({
      val: parsedPrecio,
      idMascota: item.mascota.id,
      idItem: item.id,
    });
  };

  const onPrecioFinalTransporteIdaInputChange = (
    val: React.ChangeEvent<HTMLInputElement>
  ) => {
    const parsedPrecio = parseCurrency(val.target.value, "$", ",");
    handlers.onPrecioFinalTransporteIdaChange({
      val: parsedPrecio,
      idMascota: item.mascota.id,
      idItem: item.id,
    });
  };

  const onPrecioFinalTransporteVueltaInputChange = (
    val: React.ChangeEvent<HTMLInputElement>
  ) => {
    const parsedPrecio = parseCurrency(val.target.value, "$", ",");
    handlers.onPrecioFinalTransporteVueltaChange({
      val: parsedPrecio,
      idMascota: item.mascota.id,
      idItem: item.id,
    });
  };

  const onPrecioFinalTransporteIdaVueltaInputChange = (
    val: React.ChangeEvent<HTMLInputElement>
  ) => {
    const parsedPrecio = parseCurrency(val.target.value, "$", ",");
    handlers.onPrecioFinalTransporteIdaVueltaChange({
      val: parsedPrecio,
      idMascota: item.mascota.id,
      idItem: item.id,
    });
  };
  return (
    <>
      <h4 className="mb-3">
        <div className="d-flex justify-content-between">
          <div>
            <IconContainer>
              <HotelIcon />
            </IconContainer>
            Reserva de Hotel
          </div>
          <div>
            <DangerIconContainer
              style={{ cursor: "pointer" }}
              onClick={onEliminarItemClick}
            >
              <DeleteIcon />
            </DangerIconContainer>
          </div>
        </div>
      </h4>
      <section className="mb-5">
        <div>
          <label className="mb-2" style={{ fontWeight: 500 }}>
            Fechas programadas:
          </label>
          <StyledCalendar
            preSelectedDates={diasProgramados}
            disableAll={true}
          />
        </div>
      </section>

      {item.datosTransporte && (
        <SeccionTransporte
          datos={item.datosTransporte}
          fechasReserva={item.fechasProgramadas}
        />
      )}
      <section className="mb-4">
        <h5 className="mb-3" style={{ fontWeight: 500 }}>
          <IconContainer>
            <MenuBookIcon />
          </IconContainer>
          Tarifas y planes
        </h5>
        {item.datosTarifa && (
          <Row className="mb-2">
            <Col className="col-4" style={{ fontWeight: 500 }}>
              {item.datosTarifa.tarifa.nombre + ":"}
            </Col>
            <Col className="text-right">{nochesPlan + " noches x"}</Col>
            <Col className="text-right">
              <CurrencyFormat
                className="w-100"
                name="valorFinalTarifaHotel"
                value={item.datosTarifa.precioFinal}
                thousandSeparator={","}
                onChange={onPrecioFinalTarifaInputChange}
                prefix={"$"}
                decimalSeparator={"."}
              />
            </Col>
          </Row>
        )}
        {item.datosNochesIndividuales && (
          <Row className="mb-2">
            <Col className="col-4" style={{ fontWeight: 500 }}>
              Noches individuales:
            </Col>
            <Col className="text-right">{nochesIndividuales + " noches x"}</Col>
            <Col className="text-right">
              <CurrencyFormat
                className="w-100"
                name="precioTotal"
                value={item.datosNochesIndividuales.precioFinal}
                thousandSeparator={","}
                onChange={onPrecioFinalNocheIndividualInputChange}
                prefix={"$"}
                decimalSeparator={"."}
              />
            </Col>
          </Row>
        )}
        {item.datosTransporte?.datosIda && (
          <Row className="mb-2">
            <Col className="col-4" style={{ fontWeight: 500 }}>
              Transporte ida:
            </Col>
            <Col className="text-left">{numeroViajes + " viajes x"}</Col>
            <Col className="text-right">
              <CurrencyFormat
                className="w-100"
                name="valorFinalIda"
                value={item.datosTransporte.datosIda.precioFinal}
                thousandSeparator={","}
                onChange={onPrecioFinalTransporteIdaInputChange}
                prefix={"$"}
                decimalSeparator={"."}
              />
            </Col>
          </Row>
        )}
        {item.datosTransporte?.datosVuelta && (
          <Row className="mb-2">
            <Col className="col-4" style={{ fontWeight: 500 }}>
              Transporte vuelta:
            </Col>
            <Col className="text-left">{numeroViajes + " viajes x"}</Col>
            <Col className="text-right">
              <CurrencyFormat
                className="w-100"
                name="valorFinalVuelta"
                value={item.datosTransporte.datosVuelta.precioFinal}
                thousandSeparator={","}
                onChange={onPrecioFinalTransporteVueltaInputChange}
                prefix={"$"}
                decimalSeparator={"."}
              />
            </Col>
          </Row>
        )}
        {item.datosTransporte?.datosIdaVuelta && (
          <Row className="mb-2">
            <Col className="col-4" style={{ fontWeight: 500 }}>
              Transporte ida y vuelta:
            </Col>
            <Col className="text-left">{numeroViajes + " viajes x"}</Col>
            <Col className="text-right">
              <CurrencyFormat
                className="w-100"
                name="valorFinalIdaVuelta"
                value={item.datosTransporte.datosIdaVuelta.precioFinal}
                thousandSeparator={","}
                onChange={onPrecioFinalTransporteIdaVueltaInputChange}
                prefix={"$"}
                decimalSeparator={"."}
              />
            </Col>
          </Row>
        )}
      </section>
    </>
  );
};
